export default {"src":"/_next/static/image/public/images/flags/flag_380.38544548131a0f89e7072fd56146220f.svg","height":16,"width":24};